import React, { useCallback, useMemo, useState } from "react";

import logger from "../../../../utils/LoggerFrontend";
import Actions from "../../../../Actions";
import { EditIcon } from "../../../../PagesUser/SelfServiceCampaignCreation/Previews/Svg";
import ChannelDataEditor from "../../../../PagesUser/SelfServiceCampaignCreation/Previews/Campaign__Create_ChannelDataEditor.jsx";
import { ModalConfirm } from "@talentbait/shared-components";
import { useTranslation } from "react-i18next";
import UpdateCampaignChannelsModal from "../UpdateCampaignChannelsModal/UpdateCampaignChannelsModal.jsx";
import * as sc from "./URLEditor.styled";

const urlTextStyle = {
  textAlign: "left",
  fontSize: "13px",
  fontWeight: 400,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  color: "rgb(76 79 84)"
};

//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const URLEditor = ({
  campaignData,
  isClientView,
  hasAts,
  editable,
  isReleased,
  channelsData,
  released,
  userName,
  campaignId,
  loading
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const url = useMemo(() => {
    const channelsDataToGetURL = isReleased ? released.channelsData : channelsData;
    if (campaignData.jobPostingUrl) {
      return campaignData.jobPostingUrl;
    }
    // If we don't have a campaign URL get url from first channels channelsData
    return (
      (channelsDataToGetURL && channelsDataToGetURL[Object.keys(channelsDataToGetURL)[0]]?.url) ||
      ""
    );
  }, [channelsData, isReleased, released.channelsData, campaignData.jobPostingUrl]);

  const updateURL = useCallback(
    (changes) => {
      // Update jobPostingUrl on campaign and url on every channels channelData
      const newUrl = changes?.value || url;
      Actions.toggleModal("showGenericModal", true, {
        headline: "Hinweis",
        widthVersion: "small",
        view: (
          <ModalConfirm
            showDescription={true}
            subtitle=""
            labelConfirm={"Ja"}
            description={"Möchten Sie diesen Link für alle ausgewählten Kanäle verwenden?"}
            cancelledAction={() => {
              Actions.toggleModal("showGenericModal", false);
            }}
            confirmedAction={() => {
              Actions.toggleModal("showGenericModal", false);

              Actions.updateCampaignWithId(campaignId, { jobPostingUrl: newUrl });

              if (!hasAts) {
                Actions.updateEveryChannelURL({ url: newUrl, isReleased, userName, campaignId });
              }
            }}
          />
        )
      });

      logger.log("URLEditor:updateURL", "called", { campaignId });
    },
    [isReleased, campaignId, userName, url, hasAts, isClientView]
  );

  return (
    <>
      <sc.URLLabel>{t("Link to job posting")}</sc.URLLabel>
      <sc.URLWrapper>
        <ChannelDataEditor
          updateChannelData={updateURL}
          value={url}
          urlValue={url}
          dataKey="url"
          textStyle={urlTextStyle}
          label="Link zur Stellenanzeige"
          limit={0}
          editable={editable}
          padding="16px 20px 16px 16px"
          Icon={EditIcon}
          loading={loading}
        />
      </sc.URLWrapper>

      <UpdateCampaignChannelsModal
        showModal={showModal}
        setShowModal={setShowModal}
        campaignData={campaignData}
        channels={campaignData.channels}
        isClientView={isClientView}
      />
    </>
  );
};

export default URLEditor;
